import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"
import { useTranslation } from "react-i18next"

import { InstallationReference } from "shared/types/InstallationReference"
import { ImageOverlayPayload } from "shared/ui/image-overlay/ImageOverlay"

import { InstallationReferenceFilterState } from "entities/building-references/types/InstallationReferenceFilterState"
import { ReferenceFilterChipList } from "entities/building-references/ui/reference-filter-chip-list/ReferenceFilterChipList"
import {
  InstallationReferenceFilterView,
  InstallationReferenceFilterViewModel
} from "widgets/installation-reference-selection/installation-reference-filter/InstallationReferenceFilterView"

import "./styles/_installation-reference-selection.scss"
import { InstallationReferenceSelectionListView } from "./ui/installation-reference-selection-list/InstallationReferenceSelectionListView"

export interface InstallationReferenceSelectionViewModel {
  installationReferenceFilterViewModel: InstallationReferenceFilterViewModel
  filterState: InstallationReferenceFilterState
  onFilterChange: (state: InstallationReferenceFilterState) => void
  availableInstallationReferences: InstallationReference[] | null | undefined
  selectedInstallationReferenceIDs: string[]
  onSubmit: (ev: React.FormEvent) => void
  onSelect: (selectedInstallationReferenceID: string) => void
  onZoomImage: (payload: ImageOverlayPayload) => void
  formId?: string
}

export const InstallationReferenceSelectionView = React.memo(
  ({
    installationReferenceFilterViewModel,
    filterState,
    onFilterChange,
    availableInstallationReferences,
    selectedInstallationReferenceIDs,
    onSubmit,
    onSelect,
    onZoomImage,
    formId = "installation-reference-selection"
  }: InstallationReferenceSelectionViewModel) => {
    const { t } = useTranslation()

    return (
      <ScrollArea.Root className="scroll-area scroll-area--vertical shadow-s installation-reference-selection-container">
        <ScrollArea.Viewport className="scroll-area__viewport">
          <ScrollArea.Content className="scroll-area__content installation-reference-selection">
            <InstallationReferenceFilterView
              {...installationReferenceFilterViewModel}
            />
            <ReferenceFilterChipList
              filterState={filterState}
              onChange={onFilterChange}
              productOptions={
                installationReferenceFilterViewModel.productFilterOptions
              }
            />
            <form
              id={formId}
              className="installation-reference-selection__form"
              onSubmit={onSubmit}
            >
              <InstallationReferenceSelectionListView
                isLoading={availableInstallationReferences === undefined}
                installationReferences={availableInstallationReferences}
                onSelect={onSelect}
                onZoomImage={onZoomImage}
                selectedInstallationReferenceIDs={
                  selectedInstallationReferenceIDs
                }
                className="install-ref-select__items"
                noItemText={t("InstallationReference.NoneAvailableForFilter")}
              />
            </form>
          </ScrollArea.Content>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          orientation="vertical"
          keepMounted
          className="scroll-area__scrollbar scrollbar-always-visible"
        >
          <ScrollArea.Thumb className="scroll-area__thumb" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    )
  }
)
